import { render, staticRenderFns } from "./SessionObjectCard.vue?vue&type=template&id=bc1873b4&scoped=true&"
import script from "./SessionObjectCard.vue?vue&type=script&lang=js&"
export * from "./SessionObjectCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1873b4",
  null
  
)

export default component.exports